/*
 * CV2 horizontal rails - prev/next controls.
 *
 * Binds every [data-cv2-railwrap] on the page. Loaded once and run after the
 * DOM is parsed, so it picks up all rails regardless of section order (an
 * inline per-section script only ever sees the markup above it).
 */
(function () {
  function bindRail(wrap) {
    if (wrap.dataset.cv2Bound) return;
    wrap.dataset.cv2Bound = '1';

    var rail = wrap.querySelector('[data-cv2-rail]');
    var prev = wrap.querySelector('[data-cv2-rail-prev]');
    var next = wrap.querySelector('[data-cv2-rail-next]');
    if (!rail || !prev || !next) return;

    function step() {
      // advance by one card plus its gap, falling back to most of a screenful
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 18;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) {
        // nothing overflows - hide both controls
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });

    var frame;
    rail.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    });
    window.addEventListener('resize', sync);

    // images changing the rail's scrollWidth after load
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(rail);
    }

    sync();
  }

  function init() {
    document.querySelectorAll('[data-cv2-railwrap]').forEach(bindRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-renders sections without a full page load
  document.addEventListener('shopify:section:load', init);
})();
